import es from './es.json'
import eu from './eu.json'
import en from './en.json'

export default { es, eu, en }
// translation disabled
// export default {}



// WEBPACK FOOTER //
// ./src/i18n/locales/index.js